import React, { useState } from "react";
import healthcareImg from "../../assets/s3.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot } from "react-icons/fa";
import { MdHealthAndSafety } from "react-icons/md";

const styles = `
  /* ── HEADER ── */
  .hc-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .hc-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .hc-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .hc-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .hc-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .hc-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .hc-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .hc-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .hc-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .hc-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  /* ── MAIN ── */
  .hc-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .hc-image-wrap {
    flex: 1;
  }

  .hc-image-wrap img {
    width: 100%;
    max-width: 650px;
  }

  .hc-accordion {
    flex: 1.2;
  }

  .hc-accordion-item {
    margin-bottom: 18px;
  }

  .hc-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #fff;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
  }

  .hc-accordion-body {
    padding: 20px;
    color: #555;
    line-height: 1.6;
  }

  /* ── TABLET (max-width: 1024px) ── */
  @media (max-width: 1024px) {
    .hc-header {
      height: auto;
      min-height: 90px;
    }

    .hc-header-badge {
      width: auto;
      padding: 10px 14px;
      font-size: 14px;
    }

    .hc-header-title h2 {
      font-size: 22px;
    }

    .hc-triangle-left,
    .hc-triangle-right {
      width: 50px;
    }

    .hc-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── SMALL TABLET / LANDSCAPE MOBILE (max-width: 768px) ── */
  @media (max-width: 768px) {
    .hc-header {
      flex-direction: column;
      height: auto;
    }

    .hc-header-left {
      flex: none;
      height: 80px;
      padding: 0 16px;
    }

    .hc-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
    }

    .hc-header-right {
      flex: none;
      height: 70px;
      border-top: 1px solid #e5e5e5;
    }

    .hc-triangle-left,
    .hc-triangle-right {
      width: 40px;
    }

    .hc-header-title h2 {
      font-size: 18px;
    }

    .hc-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .hc-image-wrap {
      width: 100%;
      text-align: center;
    }

    .hc-image-wrap img {
      max-width: 100%;
    }

    .hc-accordion {
      width: 100%;
      flex: none;
    }

    .hc-accordion-header {
      font-size: 14px;
      padding: 10px 16px;
    }
  }

  /* ── PORTRAIT MOBILE (max-width: 480px) ── */
  @media (max-width: 480px) {
    .hc-header-left {
      height: 70px;
      padding: 0 12px;
    }

    .hc-header-badge {
      font-size: 12px;
      padding: 8px 10px;
      gap: 8px;
    }

    .hc-header-icon-box {
      width: 28px;
      height: 28px;
    }

    .hc-header-right {
      height: 60px;
    }

    .hc-header-title h2 {
      font-size: 15px;
    }

    .hc-triangle-left,
    .hc-triangle-right {
      width: 28px;
    }

    .hc-main {
      padding: 20px 14px;
      gap: 24px;
    }

    .hc-accordion-header {
      font-size: 13px;
      padding: 9px 12px;
    }

    .hc-accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }

    .hc-accordion-item {
      margin-bottom: 12px;
    }
  }
`;

function HealthcarePage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Predictive analytics to validate the need for surgery",
      content:
        "AI technology can assist doctors to evaluate whether the operation is essentially necessary or any alternate with far less risk"
    },
    {
      title: "2.Machine learning to diagnose infectious disease",
      content:
        "With database and ML algorithms, doctors can track genetic testing to see if the illness is infectious or not."
    },
    {
      title: "3.Healthcare apps as medical assistants",
      content:
        "AI apps assist doctors in diagnosis and help patients manage health conditions efficiently."
    },
    {
      title: "4.AI-powered wearables track health conditions",
      content:
        "AI-powered wearables can keep track of patient health issues and provide suggestions."
    },
    {
      title: "5.Early detection of dementia",
      content:
        "AI tools analyze patient responses and behavior patterns to detect dementia early."
    },
    {
      title: "6.Intelligent robots in surgery",
      content:
        "Robot surgeons can assist or perform surgeries with high precision and minimal error."
    },
    {
      title: "7.Patient Care",
      content:
        "Monitoring patient health, medications, data analysis, and pregnancy management."
    },
    {
      title: "8.Research & Development",
      content:
        "AI helps in gene analytics, drug comparison, and discovering new medicines."
    },
    {
      title: "9.Healthcare Management",
      content:
        "Includes branding, pricing, risk analysis, and healthcare market research."
    },
    {
      title: "10.AI in drug discovery and production",
      content:
        "AI identifies components that help build immunity and improve drug efficiency."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="hc-header">

        {/* LEFT */}
        <div
          className="hc-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="hc-header-overlay" />

          <div className="hc-header-badge">
            <div className="hc-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto", fontSize: "22px" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="hc-header-right">
          <div className="hc-triangle-left" />
          <div className="hc-triangle-right" />

          <div className="hc-header-title">
            <MdHealthAndSafety style={{ fontSize: "32px", color: "#2fb7a4", flexShrink: 0 }} />
            <h2>Healthcare</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN ===== */}
      <div className="hc-main">

        {/* IMAGE */}
        <div className="hc-image-wrap">
          <img src={healthcareImg} alt="Healthcare" />
        </div>

        {/* ACCORDION */}
        <div className="hc-accordion">
          {data.map((item, i) => (
            <div key={i} className="hc-accordion-item">
              <div
                className="hc-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span style={{ fontSize: "22px" }}>
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="hc-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HealthcarePage;
